function cov_ab3oy52ss() {
  var path = "/app/src/constants/common.ts";
  var hash = "affcc2d44d1cc5c8440a9489c5dc928063be4e86";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/constants/common.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 34
        },
        end: {
          line: 3,
          column: 54
        }
      },
      "1": {
        start: {
          line: 5,
          column: 23
        },
        end: {
          line: 14,
          column: 10
        }
      },
      "2": {
        start: {
          line: 17,
          column: 46
        },
        end: {
          line: 17,
          column: 60
        }
      },
      "3": {
        start: {
          line: 18,
          column: 49
        },
        end: {
          line: 18,
          column: 67
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "affcc2d44d1cc5c8440a9489c5dc928063be4e86"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ab3oy52ss = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ab3oy52ss();
import { CurrencyType } from 'src/types/currency';
export var WIDGET_INITIALIZED = (cov_ab3oy52ss().s[0]++, 'Widget Initialized');
export var ACTIONS = (cov_ab3oy52ss().s[1]++, {
  UPDATE_STORE: 'updateStore',
  PREPARE_ALSHAYA_LIMIT: 'prepareAlshayaLimit',
  UPDATE_FROM_DATASET: 'updateFromDataSet',
  SET_TITLES: 'setTitles',
  PREPARE_PAY_IN_FULL_POPUP: 'preparePayInFullPopup',
  PREPARE_SCHEDULE_POPUP: 'prepareSchedulePopup',
  GET_WIDGET_DATA: 'getWidgetData',
  SHOW_LEARN_MORE: 'showLearnMore'
});
export var MOBILE_BRIDGE_QUERY_PARAM_NAME = (cov_ab3oy52ss().s[2]++, 'mobileBridge');
export var LTF_CURRENCY_LIST = (cov_ab3oy52ss().s[3]++, [CurrencyType.AED]);